import preconf from 'preconf';
// These configs are only used when developing the component locally; in
// production config is provided by tesseract through context
import democonfig from '../config/demo/config.json';

export default preconf(null, democonfig);
export const defaults = democonfig;
